module.exports = __webpack_public_path__ + "img/earth-surface.fb876dd7.png";